import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GetKeysPipe } from './get-keys.pipe';
import { FindAndHightLightTextPipe } from './find-and-hight-light-text.pipe';

@NgModule({
  imports: [IonicModule, CommonModule],
  declarations: [GetKeysPipe, FindAndHightLightTextPipe],
  exports: [GetKeysPipe, FindAndHightLightTextPipe],
})
export class CorePipeModule {}
